<base-section [index]="index" [section]="section">
  <div class="grid grid-section md-grid-cols-5 gap-l results-section">
    <div class="col-span-1">
      <div class="results-navigation">
        <ul class="results-menu">
          <li [ngClass]="{'active':displayAll}" (click)="setDisplay('displayAll')">
            <span class="title" i18n="@@All">Tous</span>
            <span class="count">{{total}}</span>
          </li>
          <li [ngClass]="{'active':displayActivities}" (click)="setDisplay('displayActivities')">
            <span class="title" i18n="@@Activities">Activités</span>
            <span class="count">{{ bookmarks.activities.length }}</span>
          </li>
          <li [ngClass]="{'active':displayRestaurants}" (click)="setDisplay('displayRestaurants')">
            <span class="title" i18n="@@Restauration">Restauration</span>
            <span class="count">{{ bookmarks.restaurants.length }}</span>
          </li>
          <li [ngClass]="{'active':displayAccommodations}" (click)="setDisplay('displayAccommodations')">
            <span class="title" i18n="@@Accommodations">Hébergements</span>
            <span class="count">{{ bookmarks.accommodations.length }}</span>
          </li>
          <li [ngClass]="{'active':displayEvents}" (click)="setDisplay('displayEvents')">
            <span class="title" i18n="@@Events">Événements</span>
            <span class="count">{{ bookmarks.events.length }}</span>
          </li>
          <li [ngClass]="{'active':displayStays}" (click)="setDisplay('displayStays')">
            <span class="title" i18n="@@Stays">Séjours</span>
            <span class="count">{{ bookmarks.stays.length }}</span>
          </li>
          <li [ngClass]="{'active':displayServices}" (click)="setDisplay('displayServices')">
            <span class="title" i18n="@@Services">Services</span>
            <span class="count">{{ bookmarks.services.length }}</span>
          </li>
          <li [ngClass]="{'active':displayOthers}" (click)="setDisplay('displayOthers')">
            <span class="title" i18n="@@Others">Autres</span>
            <span class="count">{{ bookmarks.others.length }}</span>
          </li>
        </ul>
        <div class="results-link bookmarks-download-pdf" *ngIf="total>0" (click)="onPdfClick()">
          <i class="lvi-thel-download-pdf"></i> <span i18n="@@DownloadPDF">Télécharger le PDF</span>
        </div>
        <div class="results-link bookmarks-share" *ngIf="total>0" (click)="onShareClick()">
          <i class="lvi-icon-share-outline"></i>
          <span *ngIf="!linkCopied" i18n="@@CopyShareLink">Copier le lien de partage</span>
          <span *ngIf="linkCopied" i18n="@@LinkCopied">Lien copié !</span>
        </div>
        <div class="results-link bookmarks-remove-all" *ngIf="total>0" (click)="onRemoveAllClick()">
          <i class="lvi-thel-trash"></i> <span i18n="@@DeleteAll">Tout supprimer</span>
        </div>
      </div>
    </div>
    <div class="col-span-4">
      <!-- if no bookmarks -->
      <div class="no-results" *ngIf="total===0">
        <div class="no-results-title" i18n="@@NoItemsSaved">Aucun élément enregistré.</div>
        <div class="no-results-text" i18n="@@HowToBookmark">Vous n'avez pas encore enregistré d'élément. Pour ajouter un élément à vos favoris, cliquez sur le bouton <i class="lvi lvi-thel-coeur-vide"></i> présent sur chaque fiche.</div>
      </div>
      <div class="result-items" *ngIf="bookmarks.activities.length>0 && (displayAll || displayActivities)">
        <div class="h3" i18n="@@Activities">Activités</div>
        <synapi-list-items class="list-without-map list-bookmarks" [sort]="'ids'" [pagecountMax]="displayAll?1:undefined" [col]="4" [ids]="bookmarks.activities" [standalone]="true"></synapi-list-items>
      </div>
      <div class="result-items" *ngIf="bookmarks.restaurants.length>0 && (displayAll || displayRestaurants)">
        <div class="h3" i18n="@@Restauration">Restauration</div>
        <synapi-list-items class="list-without-map list-bookmarks" [sort]="'ids'" [pagecountMax]="displayAll?1:undefined" [col]="4" [ids]="bookmarks.restaurants" [standalone]="true"></synapi-list-items>
      </div>
      <div class="result-items" *ngIf="bookmarks.accommodations.length>0 && (displayAll || displayAccommodations)">
        <div class="h3" i18n="@@Accommodations">Hébergements</div>
        <synapi-list-items class="list-without-map list-bookmarks" [sort]="'ids'" [pagecountMax]="displayAll?1:undefined" [col]="4" [ids]="bookmarks.accommodations" [size]="4" [standalone]="true"></synapi-list-items>
      </div>
      <div class="result-items" *ngIf="bookmarks.events.length>0 && (displayAll || displayEvents)">
        <div class="h3" i18n="@@Events">Événements</div>
        <synapi-list-items class="list-without-map list-bookmarks" [sort]="'ids'" [pagecountMax]="displayAll?1:undefined" [col]="4" [ids]="bookmarks.events" [size]="4" [standalone]="true"></synapi-list-items>
      </div>
      <div class="result-items" *ngIf="bookmarks.stays.length>0 && (displayAll || displayStays)">
        <div class="h3" i18n="@@Stays">Séjours</div>
        <synapi-list-items class="list-without-map list-bookmarks" [sort]="'ids'" [pagecountMax]="displayAll?1:undefined" [col]="4" [ids]="bookmarks.stays" [size]="4" [standalone]="true"></synapi-list-items>
      </div>
      <div class="result-items" *ngIf="bookmarks.services.length>0 && (displayAll || displayServices)">
        <div class="h3" i18n="@@Services">Services</div>
        <synapi-list-items class="list-without-map list-bookmarks" [sort]="'ids'" [pagecountMax]="displayAll?1:undefined" [col]="4" [ids]="bookmarks.services" [size]="4" [standalone]="true"></synapi-list-items>
      </div>
      <div class="result-items" *ngIf="bookmarks.others.length>0 && (displayAll || displayOthers)">
        <div class="h3" i18n="@@Others">Autres</div>
        <synapi-list-items class="list-without-map list-bookmarks" [sort]="'ids'" [pagecountMax]="displayAll?1:undefined" [col]="4" [ids]="bookmarks.others" [size]="4" [standalone]="true"></synapi-list-items>
      </div>
    </div>
  </div>
</base-section>
